import { useMutation, useQuery } from '@tanstack/react-query';
import { showToast } from 'app/shared/util/toast.util';
import { queryClient } from 'app/app';
import { toast } from 'react-toastify';
import {
  deletePreviousDocument,
  fetchPreviousDocument,
  fetchPreviousDocuments, fetchSavedPreviousDocument,
  savePreviousDocument
} from 'app/edozvola/cases/previous-documents/service/previous-document.service';
import { PreviousDocumentsAddFormModel } from 'app/edozvola/cases/previous-documents/model/previous-documents.model';
import { PaginationState } from 'app/shared/pagination/pagination.model';
import success = toast.success;
import error = toast.error;
import { messages, TABLE_QUERY_KEYS } from 'app/config/constants';

export const updatePreviousDocumentQuery = (uuid: string, resetForm: Function, successCallback: Function) => {
  return useMutation({
    mutationFn: (data: PreviousDocumentsAddFormModel) => savePreviousDocument(uuid, data),
    onSuccess: (data: PreviousDocumentsAddFormModel) => {
      showToast(success, messages.DATA_SAVED);
      queryClient.invalidateQueries({ queryKey: [TABLE_QUERY_KEYS.PREVIOUS_DOCUMENTS_TABLE] });
      resetForm({ values: data });
      successCallback();
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};

export const deletePreviousDocumentQuery = (uuid: string, closeModalCallback: Function) => {
  return useMutation({
    mutationFn: (webId: string) => deletePreviousDocument(uuid, webId),
    onSuccess: () => {
      showToast(success, messages.DATA_DELETED);
      queryClient.invalidateQueries({ queryKey: [TABLE_QUERY_KEYS.PREVIOUS_DOCUMENTS_TABLE] });
      closeModalCallback();
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};

export const fetchPreviousDocumentsQuery = (pagination: PaginationState, uuid: string) => {
  return useQuery({
    queryKey: [TABLE_QUERY_KEYS.PREVIOUS_DOCUMENTS_TABLE, { ...pagination }, uuid],
    queryFn: ({ signal }) => fetchPreviousDocuments({ signal, pagination, uuid }),
  });
};

export const fetchPreviousDocumentQuery = (uuid: string, webId: string) => {
  return useQuery({
    queryKey: ['previous-document', { webId: webId }],
    queryFn: () => fetchPreviousDocument({ uuid, webId }),
    enabled: !!webId,
  });
};

export const fetchSavedPreviousDocumentQuery = (uuid: string, idCasePreviousDocumentMap: string) => {
  return useQuery({
    queryKey: ['saved-previous-document', { idCasePreviousDocumentMap: idCasePreviousDocumentMap }],
    queryFn: () => fetchSavedPreviousDocument({ uuid, idCasePreviousDocumentMap }),
    enabled: !!idCasePreviousDocumentMap,
  });
};
